import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "27fe43de-b9b5-4fb5-9a91-0a1ff2be0ee3",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <mi>ρ</mi>
    <mfrac>
      <mrow>
        <mrow>
          <mi mathvariant="normal">d</mi>
        </mrow>
        <mover>
          <mi>v</mi>
          <mo stretchy="false">→</mo>
        </mover>
      </mrow>
      <mrow>
        <mrow>
          <mi mathvariant="normal">d</mi>
        </mrow>
        <mi>t</mi>
      </mrow>
    </mfrac>
    <mo>=</mo>
    <mo>−</mo>
    <mover>
      <mi mathvariant="normal">∇</mi>
      <mo stretchy="false">→</mo>
    </mover>
    <mo form="prefix" stretchy="false">(</mo>
    <mi>P</mi>
    <mo form="postfix" stretchy="false">)</mo>
</math>`,
    options: {},
  },
  {
    id: "853712e2-ef55-4285-9bfa-fa7bf36f083b",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <msub>
      <mi>ρ</mi>
      <mn>0</mn>
    </msub>
    <mfrac>
      <mrow>
        <mrow>
          <mi mathvariant="normal">d</mi>
        </mrow>
        <mover>
          <mi>v</mi>
          <mo stretchy="false">→</mo>
        </mover>
      </mrow>
      <mrow>
        <mrow>
          <mi mathvariant="normal">d</mi>
        </mrow>
        <mi>t</mi>
      </mrow>
    </mfrac>
    <mo>=</mo>
    <mo>−</mo>
    <mover>
      <mi mathvariant="normal">∇</mi>
      <mo stretchy="false">→</mo>
    </mover>
    <mo form="prefix" stretchy="false">(</mo>
    <mi>p</mi>
    <mo form="postfix" stretchy="false">)</mo>
  </math>`,
    options: {},
  },
  {
    id: "5f1baed9-441a-49cc-b065-cdcfe2905d6a",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <mi mathvariant="normal">∇</mi>
    <mo>⋅</mo>
    <mo form="prefix" stretchy="false">(</mo>
    <mi>ρ</mi>
    <mover>
      <mi>v</mi>
      <mo stretchy="false">→</mo>
    </mover>
    <mo form="postfix" stretchy="false">)</mo>
    <mo>=</mo>
    <mo>−</mo>
    <mfrac>
      <mrow>
        <mi>∂</mi>
        <mi>ρ</mi>
      </mrow>
      <mrow>
        <mi>∂</mi>
        <mi>t</mi>
      </mrow>
    </mfrac>
  </math>`,
    options: {},
  },
  {
    id: "86726d9c-05ff-4832-accd-7856ac23c06d",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <mi>ρ</mi>
    <mi mathvariant="normal">∇</mi>
    <mo>⋅</mo>
    <mo form="prefix" stretchy="false">(</mo>
    <mover>
      <mi>v</mi>
      <mo stretchy="false">→</mo>
    </mover>
    <mo form="postfix" stretchy="false">)</mo>
    <mo>=</mo>
    <mo>−</mo>
    <mfrac>
      <mrow>
        <mrow>
          <mi mathvariant="normal">d</mi>
        </mrow>
        <mi>ρ</mi>
      </mrow>
      <mrow>
        <mrow>
          <mi mathvariant="normal">d</mi>
        </mrow>
        <mi>t</mi>
      </mrow>
    </mfrac>
  </math>`,
    options: {},
  },
  {
    id: "d76cd34a-121c-4ec9-8c47-67cd1bceef88",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <msub>
      <mi>ρ</mi>
      <mn>0</mn>
    </msub>
    <mi mathvariant="normal">∇</mi>
    <mo>⋅</mo>
    <mo form="prefix" stretchy="false">(</mo>
    <msub>
      <mover>
        <mi>v</mi>
        <mo stretchy="false">→</mo>
      </mover>
      <mrow>
        <mi>a</mi>
        <mi>c</mi>
      </mrow>
    </msub>
    <mo form="postfix" stretchy="false">)</mo>
    <mo>=</mo>
    <mo>−</mo>
    <mfrac>
      <mrow>
        <mrow>
          <mi mathvariant="normal">d</mi>
        </mrow>
        <msup>
          <mi>ρ</mi>
          <mo lspace="0em" rspace="0em" class="tml-prime">′</mo>
        </msup>
      </mrow>
      <mrow>
        <mrow>
          <mi mathvariant="normal">d</mi>
        </mrow>
        <mi>t</mi>
      </mrow>
    </mfrac>
  </math>`,
    options: {},
  },
  {
    id: "a49a2613-a132-4eb4-ba76-ded2287c6887",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <mi>P</mi>
    <mo>=</mo>
    <msub>
      <mi>ρ</mi>
      <mn>0</mn>
    </msub>
    <msup>
      <mi>c</mi>
      <mn>2</mn>
    </msup>
  </math>`,
    options: {},
  },
  {
    id: "dd9b4808-538f-457b-b743-65c8b6d2474d",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <mi>p</mi>
    <msub>
      <mi>ρ</mi>
      <mn>0</mn>
    </msub>
    <mo>=</mo>
    <mi>γ</mi>
    <mi>P</mi>
    <msup>
      <mi>ρ</mi>
      <mo lspace="0em" rspace="0em" class="tml-prime">′</mo>
    </msup>

  </math>`,
    options: {},
  },
  {
    id: "2d5ca07f-16d6-4d66-a3ab-57c59f65a6fd",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <mfrac>
      <mi>p</mi>
      <msub>
        <mi>ρ</mi>
        <mn>0</mn>
      </msub>
    </mfrac>
    <mo>=</mo>
    <mfrac>
      <mrow>
        <mi>R</mi>
        <mi>T</mi>
      </mrow>
      <mi>M</mi>
    </mfrac>
  </math>`,
    options: {},
  },
  {
    id: "f305ef15-8e01-429e-8588-063c28aafaca",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <mi>P</mi>
    <mo>=</mo>
    <mi>ρ</mi>
    <msup>
      <mi>c</mi>
      <mn>2</mn>
    </msup>
  </math>`,
    options: {},
  },
  {
    id: "1c693e27-32ba-42e5-8ed2-2addb204e63a",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <mi mathvariant="normal">∇</mi>
    <mo>⋅</mo>
    <mo form="prefix" stretchy="false">(</mo>
    <msup>
      <mi>ρ</mi>
      <mo lspace="0em" rspace="0em" class="tml-prime">′</mo>
    </msup>
    <mover>
      <mi>v</mi>
      <mo stretchy="false">→</mo>
    </mover>
    <mo form="postfix" stretchy="false">)</mo>
    <mo>=</mo>
    <mo>−</mo>
    <mfrac>
      <mrow>
        <mi>∂</mi>
        <msub>
          <mi>ρ</mi>
          <mn>0</mn>
        </msub>
      </mrow>
      <mrow>
        <mi>∂</mi>
        <mi>t</mi>
      </mrow>
    </mfrac>
  </math>`,
    options: {},
  },
  {
    id: "a1424882-dc08-49cb-a879-d4e45545ef38",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <mi mathvariant="normal">∇</mi>
  <mo>⋅</mo>
  <mo form="prefix" stretchy="false">(</mo>
  <msub>
    <mi>ρ</mi>
    <mn>0</mn>
  </msub>
  <mover>
    <mi>v</mi>
    <mo stretchy="false">→</mo>
  </mover>
  <mo form="postfix" stretchy="false">)</mo>
  <mo>=</mo>
  <mo>−</mo>
  <mfrac>
    <mrow>
      <mi>∂</mi>
      <mi>ρ</mi>
    </mrow>
    <mrow>
      <mi>∂</mi>
      <mi>t</mi>
    </mrow>
  </mfrac>
  </math>`,
    options: {},
  },
  {
    id: "28701b17-ff63-432e-83ab-fcc721c1a81f",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <mi>ρ</mi>
    <mi mathvariant="normal">∇</mi>
    <mo>⋅</mo>
    <mo form="prefix" stretchy="false">(</mo>
    <mover>
      <mi>v</mi>
      <mo stretchy="false">→</mo>
    </mover>
    <mo form="postfix" stretchy="false">)</mo>
    <mo>=</mo>
    <mo>−</mo>
    <mfrac>
      <mrow>
        <mi>∂</mi>
        <mi>ρ</mi>
      </mrow>
      <mrow>
        <mi>∂</mi>
        <mi>t</mi>
      </mrow>
    </mfrac>
  </math>`,
    options: {},
  },
  {
    id: "fe71db08-e12e-411d-89ed-9813e07ba7bc",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <msub>
      <mi>ρ</mi>
      <mn>0</mn>
    </msub>
    <mfrac>
      <mrow>
        <mrow>
          <mi mathvariant="normal">d</mi>
        </mrow>
        <mover>
          <mi>v</mi>
          <mo stretchy="false">→</mo>
        </mover>
      </mrow>
      <mrow>
        <mrow>
          <mi mathvariant="normal">d</mi>
        </mrow>
        <mi>t</mi>
      </mrow>
    </mfrac>
    <mo>=</mo>
    <mo>−</mo>
    <mover>
      <mi mathvariant="normal">∇</mi>
      <mo stretchy="false">→</mo>
    </mover>
    <mo form="prefix" stretchy="false">(</mo>
    <mi>P</mi>
    <mo form="postfix" stretchy="false">)</mo>
  </math>`,
    options: {},
  },
  {
    id: "31b6cca1-1a3b-4703-ac9e-9e4c4807fcc6",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <msub>
      <mi>ρ</mi>
      <mn>0</mn>
    </msub>
    <mfrac>
      <mrow>
        <mi>∂</mi>
        <msub>
          <mover>
            <mi>v</mi>
            <mo stretchy="false">→</mo>
          </mover>
          <mrow>
            <mi>a</mi>
            <mi>c</mi>
          </mrow>
        </msub>
      </mrow>
      <mrow>
        <mi>∂</mi>
        <mi>t</mi>
      </mrow>
    </mfrac>
    <mo>=</mo>
    <mo>−</mo>
    <mover>
      <mi mathvariant="normal">∇</mi>
      <mo stretchy="false">→</mo>
    </mover>
    <mo form="prefix" stretchy="false">(</mo>
    <mi>p</mi>
    <mo form="postfix" stretchy="false">)</mo>
  </math>`,
    options: {},
  },
  {
    id: "e004b3f6-bac4-4088-af47-d17e952312ee",
    content: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
  <msup>
      <mi>ρ</mi>
      <mo lspace="0em" rspace="0em" class="tml-prime">′</mo>
    </msup>
    <mfrac>
      <mrow>
        <mi>∂</mi>
        <mover>
          <mi>v</mi>
          <mo stretchy="false">→</mo>
        </mover>
      </mrow>
      <mrow>
        <mi>∂</mi>
        <mi>t</mi>
      </mrow>
    </mfrac>
    <mo>=</mo>
    <mo>−</mo>
    <mover>
      <mi mathvariant="normal">∇</mi>
      <mo stretchy="false">→</mo>
    </mover>
    <mo form="prefix" stretchy="false">(</mo>
    <mi>p</mi>
    <mo form="postfix" stretchy="false">)</mo>
  </math>`,
    options: {},
  },
];

const groups = [
  { id: "7eee2848-089a-4f01-b137-4c3016ba5266", content: "Euler equation U<sub>0</sub> ≠ 0", options: {} },
  { id: "9c57dcfd-b21c-48e1-99da-decc02634712", content: "Mass conversation eq. U<sub>0</sub> ≠ 0", options: {} },
  { id: "c96cde14-99a1-40e2-872e-a4585de02787", content: "State equation U<sub>0</sub> = 0", options: {} },
];

export const task: Task = {
  id: "9acdf516-57b9-40ed-91dd-49bb1556b3c1",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    shuffle: true,
    sectionItemsAmount: 2,
    orientation: "vertical",
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "7eee2848-089a-4f01-b137-4c3016ba5266",
      itemsId: ["27fe43de-b9b5-4fb5-9a91-0a1ff2be0ee3", "853712e2-ef55-4285-9bfa-fa7bf36f083b"],
    },
    {
      groupId: "9c57dcfd-b21c-48e1-99da-decc02634712",
      itemsId: [
        "d76cd34a-121c-4ec9-8c47-67cd1bceef88",
        "86726d9c-05ff-4832-accd-7856ac23c06d",
        "5f1baed9-441a-49cc-b065-cdcfe2905d6a",
      ],
    },
    {
      groupId: "c96cde14-99a1-40e2-872e-a4585de02787",
      itemsId: [
        "dd9b4808-538f-457b-b743-65c8b6d2474d",
        "a49a2613-a132-4eb4-ba76-ded2287c6887",
        "f305ef15-8e01-429e-8588-063c28aafaca",
      ],
    },
  ],
};
